export const SCHOOL_CLUSTER_SUMMARY_DICTIONARY = {
  schools: "Schools",
} as const;

export const SCHOOL_CLUSTER_PANEL_DICTIONARY = {
  schoolsByLevel: "Schools by Level",
} as const;

export const SCHOOL_PANEL_BACK_DICTIONARY = {
  backToSchoolList: "Back to school list",
} as const;
